export namespace MessageHelper {
    export const MESSAGE_TYPES = {
        ready: "ready",
        playable: "playable",
        play: "play",
        pause: "pause",
        seek: "seek",
        seeked: "seeked",
        duration: "duration",
        position: "position",
        volume: "volume",
        queueItem: "queueItem",
        // Story feed only. One player per slide means GoBrain's queue - and queueItem - never runs,
        // so this is how a page knows which clip is on screen.
        storyClipChanged: "storyClipChanged",
        // The feed itself, as a pair. A host needs the bracket to attribute what happens between
        // them, and closed is what tells a page the overlay is gone however it went.
        storyFeedOpened: "storyFeedOpened",
        storyFeedClosed: "storyFeedClosed",
        // The ad slots. StoryAdSlide talks to IMA directly and creates no GoBrain play event, so
        // these are a host's only way to keep ad views out of its editorial analytics.
        adStarted: "adStarted",
        adCompleted: "adCompleted",
        adSkipped: "adSkipped",
        adNoFill: "adNoFill",
        playComplete: "playComplete",
        closePlayer: "closePlayer",
        minimizePlayer: "minimizePlayer",
        maximizePlayer: "maximizePlayer",
        openSoftboxFullScreen: "openSoftboxFullScreen",
        closeSoftboxFullScreen: "closeSoftboxFullScreen",
        mediaRestricted: "media-restricted",
        hasFormContainer: "hasFormContainer", // This is a special message type that is only used for registration form to tell the loader whether there is a form container in the player, so the loader can decide whether to open the softbox full screen or not
        presenterLayout: "presenterLayout", // The slides layout's own height, for hosts that size the player themselves
    }

    export const MESSAGE_BASE_IDENTIFIERS = {
        identifier: "Qplayer", // From QPlayer to other sites
        embeddedIdentifier: "Qplayer.Embedded", // From Embedded's sites. Only expose this to customers
        loaderIdentifier: "Qplayer.Loader", // From loaders to QPlayer
        editorIdentifier: "Qplayer.Editor" // From editor to QPlayer
    }

    export const sendMessageToLoader = ({ type, metadata, mediaId, scenarioId, qplayerId }: { type: string; metadata: any; mediaId: string, scenarioId?: string, qplayerId: string }) => {
        const messageData = {
            ...MESSAGE_BASE_DATA,
            type,
            mediaId,
            scenarioId,
            metadata,
            qplayerId
        };
        if (window !== window.parent) {
            window.parent.postMessage(JSON.parse(JSON.stringify(messageData)), '*');
        }
    }

    const MESSAGE_BASE_DATA = {
        identifier: MESSAGE_BASE_IDENTIFIERS.identifier,
    }

    export const sendMessage = ({ type, metadata, mediaId, scenarioId, qplayerId }: { type: string; metadata: any; mediaId: string, scenarioId?: string, qplayerId: string }) => {
        const messageData = {
            ...MESSAGE_BASE_DATA,
            type,
            mediaId,
            scenarioId,
            metadata,
            qplayerId
        };
        const targets = window === window.parent
            ? [window]                              // no parent — send to self only
            : [window.parent, window.top]           // has parent — skip self

        const seen = new Set()

        for (const target of targets) {
            if (target && !seen.has(target)) {
                seen.add(target)
                target.postMessage(JSON.parse(JSON.stringify(messageData)), '*');
            }
        }
    }
}
